import React from 'react';
import UpdateEmailLayout from '../../components/update-email/UpdateEmailLayout';
import UpdateEmailStart from '../../components/update-email/UpdateEmailStart';

const UpdateEmailStartPage = (props) => (
  <UpdateEmailLayout>
    <UpdateEmailStart {...props} />
  </UpdateEmailLayout>
);

export default UpdateEmailStartPage;
